var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleicona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "24px",
    viewBox: "0 0 45 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-007") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.296489 0 0 0 0 0.550462 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-007",
    transform: "translate(-798.000000, -117.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(798.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,0 C39.627417,0 45,5.372583 45,12 C45,18.627417 39.627417,24 33,24 L12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 L33,0 Z M33,4 C28.581722,4 25,7.581722 25,12 C25,16.418278 28.581722,20 33,20 C37.418278,20 41,16.418278 41,12 C41,7.581722 37.418278,4 33,4 Z",
    id: "Combined-Shape",
    fill: "#6312FF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleicona);
export default __webpack_public_path__ + "static/media/toggleicona.f04b926c52fbc50f91b0b240d782ca64.svg";
export { ForwardRef as ReactComponent };